import { ToastProvider } from '@rtkwlf/fenrir-react';

import { type Timezone } from '@packages/fenrir/fenrir-provider/timezone';

import { QueryParamsProvider } from './query-params/query-params-provider';
import { StateProvider } from './state/state-provider';
import { ThemeProvider } from './theme/theme-provider';
import { TimezoneFenrirV1Provider } from './timezone/timezone-provider-fenrir-v1';

import './date/dayjs';
import './locale/i18n'; // Note: A provider is not required as changing the language of this instance would trigger all hooks

export type PlatformProviderProps = React.PropsWithChildren<{
  themeMode?: React.ComponentProps<typeof ThemeProvider>['initialMode'];
  defaultTimezone?: Timezone;
}>;

/** This provider requires a React Router's router  */
export const PlatformProvider = ({
  children,
  themeMode,
  defaultTimezone,
}: PlatformProviderProps) => (
  <ThemeProvider initialMode={themeMode} defaultTimezone={defaultTimezone}>
    <ToastProvider>
      <StateProvider>
        <TimezoneFenrirV1Provider>
          <QueryParamsProvider>{children}</QueryParamsProvider>
        </TimezoneFenrirV1Provider>
      </StateProvider>
    </ToastProvider>
  </ThemeProvider>
);
